// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__4G2cv","alert":"SettungsInbox_alert__2QP1O"};